import jsPDF from "jspdf";
import { font, fontBold } from "@/assets/fonts/Sarabun-normal.js";

export default {
  methods: {
    async generatePdf() {
      try {
        this.localBtnDisabled = true;
        // await this.getMember();
        let pdf = new jsPDF(this.pdfOption);

        // const margin_l = this.pdfConfig.margin.l;
        const margin_t = this.pdfConfig.margin.t;
        // =========================
        // GLOBAL MARGIN
        // =========================
        const PAGE_MARGIN_X = 15;
        const PAGE_MARGIN_TOP = 15;
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginX = 10;
        const marginTop = 5;

        let pdf_position_y = PAGE_MARGIN_TOP;

        const addNewPageIfNeeded = (incrementValue) => {
          if (pdf_position_y + incrementValue >= pdfHeight - margin_t) {
            pdf.addPage();
            pdf_position_y = margin_t; // Reset the position to the top of the new page
          } else {
            pdf_position_y += incrementValue; // Add the input value
          }
        };

        pdf.addFileToVFS("Sarabun-Regular.ttf", fontBold);
        pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "bold");
        pdf.addFileToVFS("Sarabun-Regular.ttf", font);
        pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");

        pdf.setFont("Sarabun", "bold");

        pdf.setFontSize(this.pdfConfig.typo.header);
        pdf_position_y += margin_t;
        pdf.text(
          "รายงานสรุปจำนวนผู้สมัครเรียนแยกตามหลักสูตร",
          pdfWidth / 2,
          pdf_position_y,
          null,
          null,
          "center",
        );

        addNewPageIfNeeded(this.pdfConfig.endRow);
        pdf.setFont("Sarabun", "normal");
        pdf.setFontSize(this.pdfConfig.typo.extraSmall);

        this.thaitext(
          pdf,
          "วันที่พิมพ์ : " + ' ' + this.formatDateToThai(this.moment().format("YYYY-MM-DD"), false),
          pdfWidth - 20,
          pdf_position_y,
          0,
          "right"
        );

        addNewPageIfNeeded(this.pdfConfig.endNormal);

        this.thaitext(
          pdf,
          "ผู้พิมพ์ข้อมูล : " + ' ' + this.userInfo.firstName + ' ' + this.userInfo.lastName,
          pdfWidth - 20,
          pdf_position_y,
          0,
          "right"
        );

        addNewPageIfNeeded(this.pdfConfig.endNormal);
        pdf.setFontSize(this.pdfConfig.typo.small);

        this.thaitext(
          pdf,
          "ข้อมูลวันที่ : " +
            this.formatDateToThaiShort(
              this.selectedDate.start
            ) +
            " - " +
            this.formatDateToThaiShort(
              this.selectedDate.end
            ),
          PAGE_MARGIN_X,
          pdf_position_y,
        );

        addNewPageIfNeeded(this.pdfConfig.endNormal);

        pdf.setFontSize(this.pdfConfig.typo.small);
        this.thaitext(
          pdf,
          "สถาบัน : " + this.comName,
          PAGE_MARGIN_X,
          pdf_position_y,
        );

        addNewPageIfNeeded(this.pdfConfig.endNormal);

        this.thaitext(
          pdf,
          "คอร์ส : " + (this.courseData == "กรุณาพิมพ์เพื่อค้นหาชื่อหลักสูตร..." ? "ทั้งหมด" : this.courseData.courseName),
          PAGE_MARGIN_X,
          pdf_position_y,
        );

        addNewPageIfNeeded(this.pdfConfig.endNormal);

        pdf_position_y = pdf_position_y + marginTop;
        //table 1
        // ===== TABLE CONFIG =====
        const columns = [
          { key: "column1", title: "ลำดับ", ratio: 0.3 },
          { key: "column2", title: "รหัสคอร์ส", ratio: 1.0 },
          { key: "column3", title: "ชื่อคอร์ส", ratio: 1.5 },
          { key: "column4", title: "ชื่อผู้สอน", ratio: 1.0 },
          { key: "column5", title: "ราคา", ratio: 0.6 },
          { key: "column6", title: "จำนวนผู้เรียน(คน)", ratio: 1.0 }
        ];

        // =========================
        // AUTO WIDTH
        // =========================
        const totalRatio = columns.reduce((sum, col) => sum + col.ratio, 0);

        const tableWidth = pdfWidth - (marginX * 2) - 15;

        columns.forEach((col) => {
          col.width = (col.ratio / totalRatio) * tableWidth;
        });

        // =========================
        // TABLE DATA
        // =========================
        const table1Data = this.enrollSummaryData?.map((item) => ({
          column1: item.no != null
            ? Number(item.no).toLocaleString("en-US", {})
            : "-",
          column2: item.courseCode || "-",
          column3: item.c_name || "-",
          column4: item.cow_name || "-",
          column5: item.c_price != null
            ? Number(item.c_price).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "-",
          column6: item.all_enroll != null
            ? Number(item.all_enroll).toLocaleString("en-US", {})
            : "-",
        }));

        console.log(table1Data);
        // =========================
        // DRAW HEADER
        // =========================
        const HEADER_HEIGHT = 18;
        const HEADER_PADDING_TOP = 11;
        const drawHeader = () => {
          let currentX = PAGE_MARGIN_X;

          pdf.setFont("Sarabun", "bold");
          pdf.setFontSize(9);

          columns.forEach((col) => {
            pdf.setFillColor(230, 230, 230);

            pdf.rect(currentX, pdf_position_y, col.width, HEADER_HEIGHT);

            this.thaitext(
              pdf,
              col.title,
              currentX + col.width / 2 - pdf.getTextWidth(col.title) / 2,
              pdf_position_y + HEADER_PADDING_TOP,
            );

            currentX += col.width;
          });

          pdf_position_y += HEADER_HEIGHT;
        };

        drawHeader();

        // =========================
        // DRAW BODY
        // =========================
        pdf.setFont("Sarabun", "normal");
        pdf.setFontSize(8);

        const paddingX = 2;
        const paddingTop = 10;
        const paddingBottom = 0;
        const lineHeight = 8;

        table1Data.forEach((row) => {
          let currentX = PAGE_MARGIN_X;

          // =========================
          // calculate row height
          // =========================
          let maxLines = 1;

          columns.forEach((col) => {
            const text = String(row[col.key] || "");

            const lines = pdf.splitTextToSize(text, col.width - paddingX * 2);

            maxLines = Math.max(maxLines, lines.length);
          });

          const rowHeight = maxLines * lineHeight + paddingTop + paddingBottom;

          // =========================
          // page break
          // =========================
          if (pdf_position_y + rowHeight >= pdfHeight - PAGE_MARGIN_TOP) {
            pdf.addPage();

            pdf_position_y = PAGE_MARGIN_TOP;

            drawHeader();
            pdf.setFont("Sarabun", "normal");
            pdf.setFontSize(8);
          }

          // =========================
          // draw row
          // =========================
          columns.forEach((col) => {
            const text = String(row[col.key] || "");

            const lines = pdf.splitTextToSize(text, col.width - paddingX * 2);

            // border
            pdf.rect(currentX, pdf_position_y, col.width, rowHeight);

            const isCenterCol = col.key === "column1" || col.key === "column5" || col.key === "column6";

            // multiline text
            lines.forEach((line, index) => {
              const textX = isCenterCol
                ? currentX + col.width / 2 - pdf.getTextWidth(line) / 2
                : currentX + paddingX;

              this.thaitext(
                pdf,
                line,
                textX,
                pdf_position_y + paddingTop + index * lineHeight,
                {
                  align: isCenterCol ? "center" : "left",
                },
              );
            });

            currentX += col.width;
          });

          pdf_position_y += rowHeight;
        });

        // =========================
        // DRAW TOTAL ROW (สรุปท้ายตาราง)
        // =========================

        // รวมราคา (column5)
        const totalPrice = table1Data.reduce((sum, row) => {
          const price = parseFloat(String(row.column5).replace(/,/g, "")) || 0;
          return sum + price;
        }, 0);

        // รวมจำนวนผู้เรียน (column6) - ถ้าแต่ละแถวคือ 1 คน ใช้ length
        // ถ้ามี field จำนวนคนจริงๆ ต่อแถว ให้เปลี่ยนมา sum จาก field นั้นแทน
        const totalCount = table1Data.reduce((sum, row) => {
          const count = parseFloat(String(row.column6).replace(/,/g, "")) || 0;
          return sum + count;
        }, 0);

        const totalRowHeight = lineHeight + paddingTop + paddingBottom;

        // page break check ก่อนวาดแถวรวม
        if (pdf_position_y + totalRowHeight >= pdfHeight - PAGE_MARGIN_TOP) {
          pdf.addPage();
          pdf_position_y = PAGE_MARGIN_TOP;

          drawHeader();
          pdf.setFont("Sarabun", "normal");
          pdf.setFontSize(8);
        }

        pdf.setFont("Sarabun", "bold");

        let totalX = PAGE_MARGIN_X;

        // merge column1-4
        const mergedWidth =
          columns[0].width + columns[1].width + columns[2].width + columns[3].width;

        pdf.setFillColor(230, 230, 230);
        pdf.rect(totalX, pdf_position_y, mergedWidth, totalRowHeight);

        const totalLabel = "รวมทั้งหมด";
        const labelPaddingRight = 4;

        this.thaitext(
          pdf,
          totalLabel,
          totalX + mergedWidth - pdf.getTextWidth(totalLabel) - labelPaddingRight,
          pdf_position_y + paddingTop + paddingBottom,
        );

        totalX += mergedWidth;

        // column5 - รวมราคา
        const totalPriceText = totalPrice.toLocaleString("th-TH", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        pdf.setFillColor(230, 230, 230);
        pdf.rect(totalX, pdf_position_y, columns[4].width, totalRowHeight);
        this.thaitext(
          pdf,
          totalPriceText,
          totalX + columns[4].width / 2 - pdf.getTextWidth(totalPriceText) / 2,
          pdf_position_y + paddingTop + paddingBottom,
        );

        totalX += columns[4].width;

        // column6 - รวมจำนวนผู้เรียน
        const totalCountText = String(totalCount);

        pdf.setFillColor(230, 230, 230);
        pdf.rect(totalX, pdf_position_y, columns[5].width, totalRowHeight);
        this.thaitext(
          pdf,
          totalCountText,
          totalX + columns[5].width / 2 - pdf.getTextWidth(totalCountText) / 2,
          pdf_position_y + paddingTop + paddingBottom,
        );

        totalX += columns[5].width;

        pdf_position_y += totalRowHeight;

        pdf.setFont("Sarabun", "normal");

        addNewPageIfNeeded(this.pdfConfig.endRow);

        pdf.setDrawColor(0, 0, 0);

        setTimeout(() => {
          pdf.save("รายงานสรุปจำนวนผู้สมัครเรียนแยกตามหลักสูตร.pdf");
        }, 0);
        this.localBtnDisabled = false;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
